export default __webpack_public_path__ + "static/media/griddis.a11851cf.svg";